import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeWhile, finalize } from 'rxjs';

import { ApplicationsService, IApplication } from '@app/core/applications';

@Component({
  selector: 'app-application-dialog',
  templateUrl: './application-dialog.component.html',
})
export class ApplicationDialogComponent {
  public form: FormGroup;
  public saving: boolean;

  private destroyed: boolean;
  private application: IApplication;

  constructor(
    cfg: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef,
    private service: ApplicationsService
  ) {
    this.form = new FormGroup({
      code: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
    });

    if (cfg.data?.application) {
      this.application = cfg.data.application;
      this.form.patchValue({
        ...this.application,
      });
    }
  }

  public saveChanges(): void {
    this.form.markAllAsTouched();

    Object.keys(this.form.controls).forEach((key) => {
      this.form.get(key).markAsDirty();
    });

    if (!this.form.valid) {
      return;
    }

    this.saving = true;

    const op = !this.application
      ? this.service.createApplication({ ...this.form.value })
      : this.service.updateApplication({
          ...this.application,
          ...this.form.value,
        });

    op.pipe(
      takeWhile(() => !this.destroyed),
      finalize(() => (this.saving = false))
    ).subscribe((application) => {
      this.dialogRef.close(application);
    });
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }
}
